// extracted by mini-css-extract-plugin
export default {"Disclosure":"PrivatePolicy_Disclosure__3IBia","SectionTitle":"PrivatePolicy_SectionTitle__-Gu-X","Note":"PrivatePolicy_Note__5qiyW"};